import React from 'react';

const IconDelete = () => {
  return (
    <svg data-test="icondelete" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M13.4167 2.33332H12.2501H12.25H10.3722L10.1804 1.566C9.95053 0.645559 9.12346 0 8.17482 0H5.82515C4.87651 0 4.04945 0.645559 3.81954 1.56606L3.6278 2.33332H1.75005H1.75003C1.75003 2.33332 1.75003 2.33332 1.75 2.33332H0.583324C0.26116 2.33332 0 2.59451 0 2.91668C0 3.23884 0.26116 3.5 0.583324 3.5H1.19823L1.68971 12.3465C1.74133 13.2741 2.50863 14 3.43763 14H10.5625C11.4915 14 12.2587 13.2741 12.3104 12.3466L12.8019 3.5H13.4167C13.7388 3.5 14 3.23884 14 2.91668C14 2.59451 13.7388 2.33332 13.4167 2.33332ZM4.95143 1.84882C5.05159 1.44785 5.41185 1.16665 5.82518 1.16665H8.17485C8.58818 1.16665 8.94843 1.44785 9.04857 1.84877L9.16964 2.33332H4.83036L4.95143 1.84882ZM11.1455 12.2818C11.1283 12.5911 10.8723 12.8333 10.5625 12.8333H3.43763C3.12782 12.8333 2.87178 12.5911 2.85455 12.2817L2.36671 3.5H4.08335H9.91668H11.6334L11.1455 12.2818Z"
        fill="#E16862"
      />
      <path
        d="M4.66633 4.6665C4.34417 4.6665 4.08301 4.92766 4.08301 5.24983V11.0832C4.08301 11.4053 4.34417 11.6665 4.66633 11.6665C4.9885 11.6665 5.24966 11.4053 5.24966 11.0832V5.24983C5.24966 4.92766 4.9885 4.6665 4.66633 4.6665Z"
        fill="#E16862"
      />
      <path
        d="M7.00031 4.6665C6.67815 4.6665 6.41699 4.92766 6.41699 5.24983V11.0832C6.41699 11.4053 6.67815 11.6665 7.00031 11.6665C7.32247 11.6665 7.58363 11.4053 7.58363 11.0832V5.24983C7.58363 4.92766 7.32247 4.6665 7.00031 4.6665Z"
        fill="#E16862"
      />
      <path
        d="M9.33332 4.6665C9.01116 4.6665 8.75 4.92766 8.75 5.24983V11.0832C8.75 11.4053 9.01116 11.6665 9.33332 11.6665C9.65549 11.6665 9.91665 11.4053 9.91665 11.0832V5.24983C9.91668 4.92766 9.65549 4.6665 9.33332 4.6665Z"
        fill="#E16862"
      />
    </svg>
  );
};

export default IconDelete;
